import { Axios } from "@/services/_axios";
export default {
  data() {
    return {
      firstName: "",
      lastName: "",
      land: "",
      city: "",
      address: "",
      phone: "",
      cellPhone: "",
      email: "",
      institution: "",
      us_country: "",
      user_notes: "",
      house_number: "",
    };
  },
  async mounted() {
    const { data } = await Axios.get("/api/personalarea/user-info");
    if (data) {
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.land = data.land;
      this.city = data.city;
      this.address = data.address;
      this.phone = data.phone;
      this.cellPhone = data.cellPhone;
      this.email = data.email;
      this.institution = data.institution;
      this.us_country = data.us_country;
      this.user_notes = data.user_notes;
    }
  },
};
